export default __webpack_public_path__ + "static/media/07.c2517ee7.jpg";